import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";

const EventFaqs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      q: "Can adults book these packages?",
      a: "Absolutely! Our party packages are not just for kids. Adults can book them for birthdays, celebrations, team outings, family gatherings, reunions, social events, or simply a fun get-together with friends."
    },
    {
      q: "Is this only for birthday parties?",
      a: "No. While our packages are great for birthdays, they can be used for any occasion or gathering. Whether you're celebrating a milestone, organizing a team event, bringing family and friends together, or just looking for a fun sports experience, we can help customize your event."
    },
    {
      q: "Can we choose more than one sport?",
      a: "Yes. Additional sports can be added subject to field/court availability, scheduling, and any applicable additional charges. Let us know what you have in mind when making your reservation."
    },
    {
      q: "Are parents counted as participants?",
      a: "For birthday parties, non-participating parents or guardians are generally not counted toward the participant limit. If an event or package is specifically quoted on an all-inclusive or total guest-count basis, all attendees may be included in the final headcount and pricing. Our team will confirm this when finalizing your reservation."
    },
    {
      q: "Do you provide decorations?",
      a: "Decorations are not included in the standard package. You are welcome to bring your own approved decorations. If you would like help decorating, Strikes & Shots can also arrange a party host/decorator for an additional charge, subject to availability."
    },
    {
      q: "Are plates, cups, napkins and utensils included?",
      a: "Yes. Basic plates, cups, napkins and utensils are included for your event."
    },
    {
      q: "Can we arrive early to decorate?",
      a: "Yes. You may generally arrive up to 30 minutes before your scheduled event time for decorating and preparation, subject to facility availability. Please coordinate your arrival time with Strikes & Shots in advance so we can ensure the party area is ready for you."
    },
    {
      q: "What happens if our group is larger than 20 participants?",
      a: "No problem. We can customize the event based on your group size. For larger groups, contact us and we will recommend the appropriate field/court space, party area, timing, staffing, and customized pricing."
    },
    {
      q: "Do participants need to sign waivers?",
      a: "One designated Host/Renter is required to complete the event waiver and acknowledge the applicable Strikes & Shots terms, facility rules, and event responsibilities for the group. Strikes & Shots may require additional participant or parental waivers where necessary based on the activity, participant age, or event requirements."
    },
    {
      q: "Is food and beverage included in the package price?",
      a: "Food and beverages are available but are priced separately based on your group's actual needs and selections. Our team can help you choose food and beverage options based on your group size, preferences, and event requirements."
    },
    {
      q: "How long do we get the sports area?",
      a: "Each standard package includes 90 minutes of sports activity in the designated field or court area."
    },
    {
      q: "How much time do we get in the party/social area?",
      a: "Packages include approximately 45–60 minutes in the party/social area, subject to the final event schedule."
    },
    {
      q: "Are tables and chairs included?",
      a: "Yes. Tables and chairs for the designated party/social area are included with your package."
    },
    {
      q: "Is setup and cleanup included?",
      a: "Yes. Basic setup and cleanup are included with all standard party packages. Customers are responsible for removing their personal belongings and any decorations or specialty items they bring to the event."
    },
    {
      q: "Can we bring our own food?",
      a: "Outside food and catering may be subject to Strikes & Shots policies and prior approval. Please discuss any outside food requirements with our team while planning your event."
    },
    {
      q: "Which sports can we choose from?",
      a: "Depending on your selected package and facility availability, available sports include Soccer, Basketball, Volleyball, and Cricket. Small Squad currently includes Soccer. All-Star Squad and Big League allow you to choose one available sport."
    },
    {
      q: "Is our preferred field or court guaranteed?",
      a: "Fields and courts are assigned based on your selected sport, group size, facility schedule, and availability. Our team will confirm your designated playing area when your reservation is finalized."
    },
    {
      q: "When is our reservation confirmed?",
      a: "Submitting an inquiry or waiver does not automatically confirm your reservation. Your booking is confirmed once Strikes & Shots management has reviewed and approved the date, time, package, playing area, group size, pricing, and any additional requirements."
    }
  ];

  return (
    <div className="w-full py-20 bg-gray-50 px-4 md:px-8 lg:px-16">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-primaryBtnColor uppercase">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className="bg-white border border-gray-200 rounded-lg overflow-hidden transition-all duration-300 shadow-sm"
            >
              <button
                className="w-full px-6 py-4 flex justify-between items-center bg-white hover:bg-gray-50 focus:outline-none"
                onClick={() => toggleAccordion(index)}
              >
                <span className="font-heading font-bold text-left text-gray-800 text-lg">
                  {faq.q}
                </span>
                <FaChevronDown 
                  className={`text-primaryBtnHoverColor transition-transform duration-300 ${openIndex === index ? "transform rotate-180" : ""}`} 
                />
              </button>
              
              <div 
                className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? "max-h-[500px] py-4 border-t border-gray-100" : "max-h-0"}`}
              >
                <p className="font-poppins text-gray-600 text-base leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EventFaqs;
